/* =========================================================
   REISHI Lab. Morning Dew LP - Common Script
   - Sticky footer show/hide
   - Fade-in on scroll
   - FAQ accordion
   - GA4 dataLayer events
   ========================================================= */
(function () {
  window.dataLayer = window.dataLayer || [];

  function pushEvent(name, params) {
    window.dataLayer.push(Object.assign({ event: name }, params || {}));
  }

  document.addEventListener('DOMContentLoaded', function () {

    /* ---- Sticky footer CTA ---- */
    var footer = document.getElementById('lpStickyFooter');
    var faqSection = document.getElementById('s14');
    var stickyImpressed = false;

    function handleScroll() {
      if (!footer) return;
      if (window.scrollY > 100) {
        footer.classList.add('show');
        if (!stickyImpressed) {
          stickyImpressed = true;
          pushEvent('sticky_cta_impression', {});
        }
      } else {
        footer.classList.remove('show');
      }
      if (faqSection) {
        var rect = faqSection.getBoundingClientRect();
        var inFaq = rect.top < window.innerHeight * 0.5 && rect.bottom > 0;
        footer.classList.toggle('hide-on-faq', inFaq);
      }
    }
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    /* ---- Fade-in on scroll ---- */
    var fadeEls = document.querySelectorAll('.lp-fade-in');
    if ('IntersectionObserver' in window) {
      var fadeObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) entry.target.classList.add('lp-visible');
        });
      }, { threshold: 0.2 });
      fadeEls.forEach(function (el) { fadeObserver.observe(el); });
    } else {
      fadeEls.forEach(function (el) { el.classList.add('lp-visible'); });
    }

    /* ---- Section view tracking (GA4) ---- */
    var sections = document.querySelectorAll('[data-section]');
    if ('IntersectionObserver' in window) {
      var seen = {};
      var sectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var name = entry.target.getAttribute('data-section');
          if (entry.isIntersecting && !seen[name]) {
            seen[name] = true;
            pushEvent('section_view', { section_name: name });
          }
        });
      }, { threshold: 0.5 });
      sections.forEach(function (el) { sectionObserver.observe(el); });
    }

    /* ---- Scroll depth tracking (GA4) ---- */
    var depths = [25, 50, 75, 100];
    var reached = {};
    function checkScrollDepth() {
      var scrollTop = window.scrollY;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;
      var pct = Math.round((scrollTop / docHeight) * 100);
      depths.forEach(function (d) {
        if (pct >= d && !reached[d]) {
          reached[d] = true;
          pushEvent('scroll_depth', { percent_scrolled: d });
        }
      });
    }
    window.addEventListener('scroll', checkScrollDepth, { passive: true });

    /* ---- CTA click tracking (GA4) ---- */
    document.querySelectorAll('[data-cta-location]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        pushEvent('cta_click', { cta_location: btn.getAttribute('data-cta-location') });
      });
    });

    /* ---- FAQ accordion ---- */
    document.querySelectorAll('.lp-faq-item').forEach(function (item) {
      item.addEventListener('click', function () {
        item.classList.toggle('open');
        if (item.classList.contains('open')) {
          pushEvent('faq_open', { question_id: item.getAttribute('data-question-id') || '' });
        }
      });
    });
  });
})();